import { render, staticRenderFns } from "./addPlat.vue?vue&type=template&id=69e65ae6&"
import script from "./addPlat.vue?vue&type=script&lang=js&"
export * from "./addPlat.vue?vue&type=script&lang=js&"
import style0 from "./addPlat.vue?vue&type=style&index=0&id=69e65ae6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports